
import React, { useState, useEffect } from 'react';
import { Breadcrumb, BreadcrumbItem, Button } from 'carbon-components-react';
import Add16 from "@carbon/icons-react/lib/add/16";
import QualityCheckTable from './QualityCheckTable';
import { DataTableSkeleton, Pagination } from 'carbon-components-react';
import { useHistory } from 'react-router-dom';
import callGetApi from 'requests/GetRequests';
import * as Constants from '../../requests/URLConstants';
import i18n from "../../i18n";
import axios from "axios";

require("./_quality-check.scss");
var config = require('../../config/appConfig.json');

const QualityCheckPage = props => {

    const [headers, setheaders] = useState([
        {
            key: 'Response_Number',
            header: i18n.t('qualityCode.requestID')
        }, {
            key: 'project_name',
            header: i18n.t('qualityCode.projectName')
        }, {
            key: 'File_Name',
            header: i18n.t('qualityCode.fileName')
        }, {
            key: 'request_user',
            header: i18n.t('qualityCode.User')
        }, {
            key: 'Error_Description',
            header: i18n.t('qualityCode.remarks')
        }, {
            key: 'Last_Updated_Time',
            header: i18n.t('qualityCode.lastUpdated')
        }, {
            key: 'Status',
            header: i18n.t('qualityCode.status')
        }]);

    const [rows, setrows] = useState([]);
    const [loader, setloader] = useState(true);
    const [paginatedRows, setPaginatedRows] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [firstRowIndex, setFirstRowIndex] = useState(0);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const history = useHistory();
    const home = i18n.t('qualityCode.Home');
    const qualityCheck = i18n.t('qualityCode.qualityCheck');
    const previousPage = i18n.t('qualityCode.Previouspage');
    const nextPage = i18n.t('qualityCode.nextPage');
    const Itemspage = i18n.t('qualityCode.Itemspage');
    const nodataavailable = i18n.t('qualityCode.Nodataavailable');
    const Add = i18n.t('qualityCode.Add');



    useEffect(() => {
        getQualityCheckData();
    }, []);

    function formatData(data) {
        let date;
        data.forEach(function (element) {
            date = new Date(element.Last_Updated_Time);
            date = ("0" + date.getDate()).slice(-2) + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + date.getFullYear();
            element.Last_Updated_Time = date;
        });
        return data;
    }

    function getQualityCheckData() {
        setloader(true);
        let data = [];
        let formattedData = [];
        callGetApi(Constants.CODEQUALITYCHECKFILESUBMISSIONLIST, {
            'Content-Type': 'application/json'
        }).then(response => {
            data = response;
            formattedData = formatData(response)
            setrows(formattedData);
            setloader(false);
        }).catch(() => {
            setloader(false);
        });
    }

    useEffect(() => {
        if (rows.length) {
            setTotalItems(rows.length);
            getPaginatedRows(firstRowIndex, currentPageSize);
        }
    }, [rows])

    function goToCompletedResult(selectedRow) {
        history.push({
            pathname: '/qualityCheck/completedQualityCheck',
            requestId: selectedRow.cells[2].value,
            id: selectedRow.id
        })
    }

    function getPaginatedRows(param, pageSize) {
        let startingIndex = Number.isInteger(param) ? param : firstRowIndex;
        let slicedRows = rows.slice(startingIndex, startingIndex + pageSize);
        setPaginatedRows(slicedRows);
    }

    return (
        <div className="quality-check-wrapper">
            <div className="quality-check-container">
                <div className="quality-check-header" style={{boxShadow: '0 2px 4px 0 rgba(0,0,0,0.5)'}}>
                    <div>
                        <Breadcrumb aria-label="Page navigation">
                            <BreadcrumbItem href='/homepage'>
                                {home}
                            </BreadcrumbItem>
                        </Breadcrumb>
                        <div className="title">
                            {qualityCheck}
                        </div>
                    </div>
                    <div>
                        <Button renderIcon={Add16} onClick={() => history.push('/qualityCheck/uploadFile')}>{Add}</Button>
                    </div>
                </div>
                <div className="quality-table">
                    {!loader ?
                        rows.length ?
                            <div>
                                <QualityCheckTable rows={paginatedRows} fullRows={rows}
                                    headers={headers} goToCompletedResult={goToCompletedResult} showReload={true} getQualityCheckData={getQualityCheckData}
                                />
                                <Pagination
                                    totalItems={totalItems}
                                    backwardText={previousPage}
                                    forwardText={nextPage}
                                    pageSize={currentPageSize}
                                    pageSizes={[5, 10, 15, 25]}
                                    itemsPerPageText={Itemspage}
                                    onChange={({ page, pageSize }) => {
                                        let newFirstRowIndex = pageSize * (page - 1);
                                        setFirstRowIndex(newFirstRowIndex)
                                        getPaginatedRows(newFirstRowIndex, pageSize);
                                    }}
                                />
                            </div>
                            :
                            <div className="center-align">
                                {nodataavailable}
                            </div>
                        :
                        <DataTableSkeleton
                            columnCount={headers.length}
                            rowCount={3}
                        />
                    }
                </div>
            </div>
        </div>
    );
};

export default QualityCheckPage;

